
export default {
  getLogsWeezeo: (fromDate, toDate) => {
    return {
      url: '/logs/env/:env',
      method: 'GET',
      route_params: {
        env: 'weezeo'
      },
      get_params: {
        fromDate,
        toDate
      }
    };
  }
};



// WEBPACK FOOTER //
// ./environments/logging/data/LogsWeezeo/api.js